import React from 'react';

type Props = {
    className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
        <path d="M10.6 16.6L17.7 9.5L16.3 8.1L10.6 13.8L7.7 10.9L6.3 12.3L10.6 16.6ZM12 22C10.6 22 9.3 21.7 8.1 21.2C6.9 20.7 5.8 20 4.9 19.1C4 18.2 3.3 17.1 2.8 15.9C2.3 14.7 2 13.4 2 12C2 10.6 2.3 9.3 2.8 8.1C3.3 6.9 4 5.8 4.9 4.9C5.8 4 6.9 3.3 8.1 2.8C9.3 2.3 10.6 2 12 2C13.4 2 14.7 2.3 15.9 2.8C17.1 3.3 18.2 4 19.1 4.9C20 5.8 20.7 6.9 21.2 8.1C21.7 9.3 22 10.6 22 12C22 13.4 21.7 14.7 21.2 15.9C20.7 17.1 20 18.2 19.1 19.1C18.2 20 17.1 20.7 15.9 21.2C14.7 21.7 13.4 22 12 22ZM12 20C14.2 20 16.1 19.2 17.7 17.7C19.3 16.2 20 14.3 20 12C20 9.7 19.2 7.9 17.7 6.3C16.2 4.7 14.3 4 12 4C9.7 4 7.9 4.8 6.3 6.3C4.7 7.8 4 9.7 4 12C4 14.3 4.8 16.1 6.3 17.7C7.8 19.3 9.7 20 12 20Z" 
        fill="currentColor" />
    </svg>
);

export default Icon;
